export default __webpack_public_path__ + "static/media/four.d28aee01.png";